import clsx from "clsx";
import { CircleAlert, CircleCheck, Info, TriangleAlert } from "lucide-react";
import { node, oneOf, string } from "prop-types";

import classes from "./InfoBox.module.scss";

export const infoBoxVariants = {
  grey: "grey",
  info: "info",
  success: "success",
  warning: "warning",
  danger: "danger",
};

const variantIcons = {
  [infoBoxVariants.grey]: Info,
  [infoBoxVariants.info]: Info,
  [infoBoxVariants.success]: CircleCheck,
  [infoBoxVariants.warning]: TriangleAlert,
  [infoBoxVariants.danger]: CircleAlert,
};

const InfoBox = ({ variant, className, children, footer }) => {
  const VariantIcon = variantIcons[variant];

  return (
    <div
      className={clsx(classes["info_box"], classes[`info_box--${variant}`], className)}
      data-testid="info-box"
      data-variant={variant}
    >
      <div className={classes["info_box__body"]}>
        <VariantIcon size={16} className={classes["info_box__icon"]} />
        <div className={classes["info_box__content"]}>{children}</div>
      </div>

      {footer && (
        <>
          <hr className={classes["info_box__divider"]} />
          <div className={classes["info_box__footer"]}>{footer}</div>
        </>
      )}
    </div>
  );
};

InfoBox.propTypes = {
  variant: oneOf(Object.values(infoBoxVariants)).isRequired,
  className: string,
  children: node.isRequired,
  footer: node,
};

export default InfoBox;
